/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

export abstract class ClipboardDesktopService {
   public static readonly delayTime = 300;
   public abstract onMonitorReady(): void;
   public abstract shouldSkipPaste(timeOnFocusCurrentWindow: number): boolean;
   public abstract blockKeyEventOnFocus(timeOnFocusCurrentWindow: number, updateKey: Function): void;
   public getMainWindow = () => {
      let windows = chrome.app.window.getAll();
      for (let i = 0; i < windows.length; i++) {
         if (windows[i].id === "HTMLAccessChromeWindow") {
            return windows[i];
         }
      }
      return null;
   };
}
